export enum ShowcaseCardVariant {
  LANDING_PAGE = 'landing-page',
  SHOWCASE_PAGE = 'showcase-page',
}
